class Auth {
  static getIsPhoneAuth(context) {
    return new Promise((resolve, reject) => {
      context.$store
        .dispatch({
          type: "IsPhoneAuth",
        })
        .then(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  static IsPublic(context, mid) {
    return new Promise((resolve, reject) => {
      context.$store
        .dispatch({
          type: "MemorialHallIsPublic",
          mid: mid,
        })
        .then(
          (res) => {
            resolve(res);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
  static IsFriend(context, mid) {
    // console.log(mid,"IsFriend run......");
    var _id = mid;
    var _isPass = sessionStorage.getItem(_id);
    if (_isPass != "true") {
      context.$store
        .dispatch({
          type: "MemorialHallIsFriend",
          mid: mid
        })
        .then(
          (res) => {
            if (!res) {
              context.$router.replace("/memorialHallValidate?id=" + _id);
            }
          },
          (err) => {}
        );
    }

    // return new Promise((resolve, reject) => {
    //   context.$store
    //     .dispatch({
    //       type: "MemorialHallIsFriend",
    //       mid: mid,
    //     })
    //     .then(
    //       (res) => {
    //         resolve(res);
    //       },
    //       (err) => {
    //         reject(err);
    //       }
    //     );
    // });
  }
}

export default Auth;
